import React from 'react';
import { Button, Input, Card, message, Form, TreeSelect } from 'antd';
import common from '../../assets/common.js';
import './index.css';

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const FormItem = Form.Item;

class Add extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    treeData: [],
    example: []
  };
  componentWillMount(){
    this.getArea();
  }
  handleSubmit = (e) => {
    let this_ = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (!err) {
          let roomIds = [];
          let buildings = [];
          let areaIds = [];
          this_.state.example.map((item) => {
            if(values["area"].indexOf(item.value) > -1) {
              if(item.dept === 3) {
                roomIds.push(item.id);
                values["roomIds"] = roomIds;
              } else if(item.dept === 2){
                buildings.push(item.id);
                values["buildingIds"] = buildings;
              } else {
                areaIds.push(item.id);
                values["areaIds"] = areaIds;
              }
            }
          })
          delete values["area"];
          this_.submit(values);
        }

      }
    });
  }
  submit = (values) => {
    let postData = values;
    postData["_url"] = 'api/admin/sub';
    postData["_method"] = 'POST';
    common.request(postData, this, function(obj, result){
      message.info("创建成功");
      window.location.href = "#/sub";
    },function(obj, data){
      message.warning(data.message);
    });
  }
  getArea = () => {
    let this_ = this;
    var postData = {};
    postData["_url"] = "api/dc/access/area";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = "roomId" + dataItem.roomId;
                arr3["id"] = dataItem.roomId;
                arr3["value"] = "roomId" + dataItem.roomId;
                arr3["dept"] = 3;
                let example = this_.state.example;
                example.push(arr3)
                this_.setState({
                  example
                })
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = "buildingId" + item.buildingId;
            arr2["id"] = item.buildingId;
            arr2["value"] = "buildingId" + item.buildingId;
            arr2["dept"] = 2;
            let example = this_.state.example;
            example.push(arr2)
            this_.setState({
              example
            })
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = "areaId" + index.areaId;
        arr1["id"] = index.areaId;
        arr1["value"] = "areaId" + index.areaId;
        arr1["dept"] = 1;
        let example = this_.state.example;
        example.push(arr1)
        this_.setState({
          example
        })
        return arr1;
      });
      console.log(this_.state.example);
      obj.setState({
        treeData: ar
      })
    }, function(obj, state) {

    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {xs: { span: 24 },sm: { span: 6 },},
      wrapperCol: {xs: { span: 24 },sm: { span: 14 },},
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width: 300
      },
    };
    // let orgLogo = this.state.orgLogo;
    return (
      <Card>
        <Form onSubmit={this.handleSubmit} style={{maxWidth: 1020}}>
          <FormItem
            {...formItemLayout}
            label="账号"
          >
            {getFieldDecorator('userName', {
              rules: [{
                required: true, message: '请填写登录账号!',
              }],
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="密码"
          >
            {getFieldDecorator('passWord', {
              rules: [{
                required: true, message: '请填写登录密码!',
              }],
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="选择区域"
          >
            {getFieldDecorator('area', {
              rules: [{
                required: true, message: '请选择区域!',
              }],
            })(
              <TreeSelect {...tProps} />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">提交</Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}
const addFrom = Form.create()(Add);
export default addFrom;



// WEBPACK FOOTER //
// ./src/component/sub/add.js